import React from 'react';
// components
import { CardBusinessListing } from '../CardBusinessListing';
import { CardForContentSummary } from '../CardForContentSummary';
import { isBrowser, makeImgResizerUrl } from '@jelly/utils';

var SponsoredAds = function SponsoredAds(_ref) {
  var result = _ref.result;
  return /*#__PURE__*/React.createElement(CardBusinessListing, {
    headline: result.dek,
    thumbnail: result.thumbnail ? makeImgResizerUrl({
      src: result.thumbnail,
      method: 'r',
      w: 100,
      h: 100
    }) : '',
    title: result.title,
    url: result.canonical
  });
};

var ContentSummary = function ContentSummary(_ref2) {
  var result = _ref2.result,
      showContentDescription = _ref2.showContentDescription;
  var author = result.author,
      canonical = result.canonical,
      description = result.description,
      doc_type = result.doc_type,
      modified_at = result.modified_at,
      sponsored = result.sponsored,
      subtitle = result.subtitle,
      thumbnail = result.thumbnail,
      title = result.title,
      total_answers = result.total_answers;
  return /*#__PURE__*/React.createElement(CardForContentSummary, {
    author: author,
    blurb: showContentDescription ? description : null,
    displayModified: modified_at,
    docType: doc_type,
    key: title,
    outerUrl: canonical,
    isSponsored: sponsored,
    subtitle: subtitle,
    thumbnail: makeImgResizerUrl({
      src: thumbnail === null ? undefined : thumbnail.path,
      method: doc_type === 'review' ? 'r' : 'rc',
      w: 100,
      h: 75
    }),
    title: title,
    total_answers: total_answers
  });
};

export function ResultsList(_ref3) {
  var _ref3$results = _ref3.results,
      results = _ref3$results === void 0 ? [] : _ref3$results,
      _ref3$searchTerm = _ref3.searchTerm,
      searchTerm = _ref3$searchTerm === void 0 ? '' : _ref3$searchTerm,
      _ref3$showAdUnit = _ref3.showAdUnit,
      showAdUnit = _ref3$showAdUnit === void 0 ? true : _ref3$showAdUnit,
      _ref3$showContentDesc = _ref3.showContentDescription,
      showContentDescription = _ref3$showContentDesc === void 0 ? true : _ref3$showContentDesc,
      _ref3$showSponsoredAd = _ref3.showSponsoredAds,
      showSponsoredAds = _ref3$showSponsoredAd === void 0 ? false : _ref3$showSponsoredAd;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!results.length && results.map(function (result, index) {
    switch (result.doc_type) {
      case 'adunit':
        if (isBrowser()) {
          window.googletag && window.googletag.apiReady && window.googletag.pubads().setTargeting('search_term', searchTerm).refresh();
        }

        return showAdUnit && /*#__PURE__*/React.createElement("div", {
          id: "in-article-vca-1",
          className: "ad-unit",
          key: "".concat(result.guid).concat(index)
        });

      case 'business_listing':
      case 'featured_listing':
        return null;

      case 'article':
      case 'category':
      case 'infographic':
      case 'review':
      case 'user':
      case 'video':
      case 'whitepaper':
        return /*#__PURE__*/React.createElement(ContentSummary, {
          key: "".concat(result.guid).concat(index),
          result: result,
          showContentDescription: showContentDescription
        });

      case 'qtWidget':
        return result.qtWidget;

      default:
        return null;
    }
  }));
}